<script lang="ts">
	import { Container } from '@Shelly/shelly-design-system';

	export let useContainer = false;
</script>

{#if useContainer}
	<Container type="borderSolid" backgroundColor="color-base">
		<slot />
	</Container>
{:else}
	<div>
		<slot />
	</div>
{/if}
